import {
  Directive,
  EnvironmentInjector,
  ViewContainerRef,
  inject,
  input,
  booleanAttribute,
  effect,
} from '@angular/core';
import { DisclaimerWidgetComponent } from './widget/disclaimer-widget.component';

@Directive({
  selector: '[compAiGeneratedContentDisclaimer]',
  standalone: true,
  host: {
    class: 'ai-generated-content',
  },
})
export class AiGeneratedContentDirective {
  readonly text = input<string | undefined, string | undefined>(undefined, {
    alias: 'compAiGeneratedContentTextInput',
    transform: (value) => value?.trim() || undefined,
  });

  readonly isLessImportant = input(true, {
    alias: 'compAiGeneratedContentLessImportant',
    transform: booleanAttribute,
  });

  readonly textAlign = input<'left' | 'center' | 'right'>('center', {
    alias: 'compAiGeneratedContentTextAlign',
  });

  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly environmentInjector = inject(EnvironmentInjector);

  constructor() {
    const disclaimerRef = this.viewContainerRef.createComponent(DisclaimerWidgetComponent, {
      environmentInjector: this.environmentInjector,
    });

    effect(() => {
      disclaimerRef.setInput('text', this.text());
      disclaimerRef.setInput('isLessImportant', this.isLessImportant());
      disclaimerRef.setInput('alignment', this.textAlign());
    });
  }
}
